export default __webpack_public_path__ + "static/media/twitterIcon.dc4f244b.svg";